import { FIND_YOUR_THING } from '../ids';

const theme = {
  name: 'Find Your Thing',
  id: FIND_YOUR_THING,
  };

export default theme;
